import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { InferType } from 'yup'
import { societyCreatePostSchema } from '../../../forms/schemas/society_create_post'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { Checkbox } from '../../common/Checkbox'
import { Icon, IconChoices } from '../../common/Icon'
import { Label } from '../../common/Label'

interface PinnedCheckboxProps {
  control: Control<InferType<typeof societyCreatePostSchema>>
  watchPinned: boolean
}

export const PinnedCheckbox = ({
  control,
  watchPinned,
}: PinnedCheckboxProps): JSX.Element => {
  const { translate } = useAppTranslation()

  return (
    <Controller
      control={control}
      name="pinned"
      render={({ field: { name, value, onChange } }) => (
        <div
          className={`flex items-center justify-center gap-2 rounded border border-solid border-neutral-80 px-4 py-3 ${
            watchPinned && 'border-brandGreen'
          }`}
          style={
            watchPinned ? { backgroundColor: theme.colors.brandLightGreen } : {}
          }
        >
          <Checkbox
            name={name}
            onChange={onChange}
            value={!!value}
            type="checkbox"
          />
          <Label
            name={name}
            label={translate('common.actions.pin')}
            className="cursor-pointer"
            style={theme.textVariants.base}
          />
          <Icon icon={IconChoices.PIN} size={20} highlighted />
        </div>
      )}
    />
  )
}
